export default {
	method: "GET",
};